import {useMutation} from "@tanstack/react-query";
import {saveAccountAddressInfo} from "../../../../../api/correspondent/CorresspondentApi";
import {CreateAddress} from "../interface";

export const useSaveAccountAddressInfo = () => {

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: CreateAddress) => saveAccountAddressInfo(data),
        onSuccess: () => {
        },
        onError: (error) => {
            console.log("update error", error);
        },
    });

    return {mutate, mutateAsync};
};
